import { groupBy } from "lodash"

interface GroupedArray {
  groupName: string
  items: any[]
}

const groupPaths = [
  {
    name: "Phones",
    path: "/products/phones/mudita-kompakt",
  },
  { name: "Alarm Clocks", path: "/products/alarm-clocks" },
  { name: "Watches", path: "https://store.mudita.com/store/watches" },
  { name: "Budziki", path: "/pl/products/alarm-clocks" },
  { name: "Zegarki", path: "https://store.mudita.com/store/watches" },
  {
    name: "Telefony",
    path: "/pl/products/phones/mudita-kompakt",
  },
]

export const groupByKey = (items: any[], key: any): GroupedArray[] => {
  const grouped = groupBy(items, key)

  return Object.keys(grouped).map((groupName) => {
    const groupPath =
      groupPaths.find(
        (path) => path.name.toLowerCase() === groupName.toLowerCase()
      )?.path ?? ""

    return {
      groupName,
      groupPath: groupPath,
      hiddenItem: grouped[groupName][0].hiddenItem,
      items: grouped[groupName],
    }
  })
}
